import React from 'react';
import { Navbar, Nav,  Breadcrumb, Image } from 'react-bootstrap';
import { Link, NavLink, useLocation } from "react-router-dom";
import { paths, headerData } from '../Data/data';

const Header = () => {
  const location = useLocation()

  return (
    <Navbar role="banner" sticky='top' expand={false} className='header'>
        <Navbar.Brand className="col-lg-3">
          <Link to={paths.etusivu} className="headerLogoContainer"><Image src={headerData.headerLogo} alt={headerData.headerAlt} className="headerLogo" /></Link>
        </Navbar.Brand>
        <Navbar.Text className="col-lg-3 text-center headerTextContainer">
          <Navbar.Brand className="headerText">{location.pathname.substring(1).toUpperCase()}</Navbar.Brand>
        </Navbar.Text>
        <Nav className="col-md-12 col-lg-3 headerNav">
          <Breadcrumb className="">
            {
              headerData.choicePath.includes(location.pathname) &&
              <>
              <Breadcrumb.Item key="choiceNavLink1" linkAs={NavLink} linkProps={{ to: paths.arki, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.arki.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="choiceNavLink2" linkAs={NavLink} linkProps={{ to: paths.motivaatio, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.motivaatio.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="choiceNavLink3" linkAs={NavLink} linkProps={{ to: paths.osaaminen, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.osaaminen.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="choiceNavLink4" linkAs={NavLink} linkProps={{ to: paths.hakutaidot, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.hakutaidot.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="choiceNavLink5" linkAs={NavLink} linkProps={{ to: paths.yhteenveto, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.yhteenveto.substring(1)}</Breadcrumb.Item>
              </>
            }
            {
              headerData.adjustPath.includes(location.pathname) &&
              <>
              <Breadcrumb.Item key="adjustNavLink1" linkAs={NavLink} linkProps={{ to: paths.arkeni, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.arkeni.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="adjustNavLink2" linkAs={NavLink} linkProps={{ to: paths.motivaationi, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.motivaationi.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="adjustNavLink3" linkAs={NavLink} linkProps={{ to: paths.osaamiseni, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.osaamiseni.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="adjustNavLink4" linkAs={NavLink} linkProps={{ to: paths.hakutaitoni, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.hakutaitoni.substring(1)}</Breadcrumb.Item>
              <Breadcrumb.Item key="adjustNavLink5" linkAs={NavLink} linkProps={{ to: paths.tavoitteeni, activeStyle:{ color: headerData.activeNavElementColor }, className:"choicePathElement" }}>{paths.tavoitteeni.substring(1)}</Breadcrumb.Item>
              </>
            }
          </Breadcrumb>
        </Nav>
    </Navbar>
  );
};

export default Header;